import { ME_IS_FETCHING, ME_GET_SUCCESS, ME_GET_ERROR } from './constants';

// Initial State
export const initialState = {
  isFetching: false,
  info: {},
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ME_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case ME_GET_SUCCESS:
      if (window.initiateHightlightIO) {
        window.initiateHightlightIO(action.payload);
      }
      if (window.initiateWebsiteFeedback) {
        window.initiateWebsiteFeedback(action.payload);
      }
      return {
        ...state,
        isFetching: false,
        error: null,
        info: action.payload || {}
      };

    case ME_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
